(function () {
  // roundRect polyfill for older browsers
  if (!CanvasRenderingContext2D.prototype.roundRect) {
    CanvasRenderingContext2D.prototype.roundRect = function(x, y, width, height, radius) {
      this.beginPath();
      this.moveTo(x + radius, y);
      this.lineTo(x + width - radius, y);
      this.quadraticCurveTo(x + width, y, x + width, y + radius);
      this.lineTo(x + width, y + height - radius);
      this.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
      this.lineTo(x + radius, y + height);
      this.quadraticCurveTo(x, y + height, x, y + height - radius);
      this.lineTo(x, y + radius);
      this.quadraticCurveTo(x, y, x + radius, y);
      this.closePath();
    };
  }

  function formatMoney(cents, moneyFormat) {
    const amount = (cents / 100).toFixed(2);
    return moneyFormat.replace("{{amount}}", amount);
  }

  function sumQty(map) {
    let total = 0;
    Object.values(map).forEach((n) => (total += n));
    return total;
  }

  function ensure(el, msg) {
    if (!el) throw new Error(msg);
    return el;
  }

  function initBundleBuilder(sectionEl) {
    const sectionId = sectionEl.dataset.sectionId;
    const storageKey = `bb_selections_${sectionId}`;
    const productsJsonEl = ensure(sectionEl.querySelector("[data-bb-products]"), "Products JSON not found");
    const collectionsJsonEl = sectionEl.querySelector("script[data-bb-collections]");
    let collections = [];
    if (collectionsJsonEl && collectionsJsonEl.textContent) {
      try {
        const raw = collectionsJsonEl.textContent.trim();
        collections = raw ? JSON.parse(raw) : [];
      } catch (e) {
        console.warn("Bundle Builder: collections JSON parse failed", e);
      }
    }
    if (!Array.isArray(collections)) collections = [];
    const collectionsWrap = sectionEl.querySelector("[data-bb-collections-ui]");
    const collectionsSelect = sectionEl.querySelector("[data-bb-collections-select]");
    const searchInput = sectionEl.querySelector("[data-bb-search-input]");
    const searchToggle = sectionEl.querySelector("[data-bb-search-toggle]");
    const searchWrapper = sectionEl.querySelector(".bb__searchwrapper");
    const searchEl = sectionEl.querySelector("[data-bb-search]");

    const collectionsByTab = { 1: [], 2: [] };
    collections.forEach((c) => {
      const t = Number(c.tab) || 1;
      if (!collectionsByTab[t]) collectionsByTab[t] = [];
      collectionsByTab[t].push({ handle: String(c.handle || ""), title: String(c.title || "") });
    });

    // aynı handle birden fazla kez geldiyse tekilleştir
    [1, 2].forEach((t) => {
      const seen = new Set();
      collectionsByTab[t] = (collectionsByTab[t] || []).filter((x) => {
        if (!x.handle) return false;
        if (seen.has(x.handle)) return false;
        seen.add(x.handle);
        return true;
      });
    });

    const activeCollection = { 1: null, 2: null };
    [1, 2].forEach((t) => {
      activeCollection[t] = collectionsByTab[t]?.[0]?.handle || null;
    });

    let products = [];
    try {
      const rawProducts = (productsJsonEl.textContent || "").trim();
      products = rawProducts ? JSON.parse(rawProducts) : [];
    } catch (e) {
      console.warn("Bundle Builder: products JSON parse failed", e);
    }
    if (!Array.isArray(products)) products = [];

    const moneyFormat = sectionEl.dataset.moneyFormat || "{{amount}}";
    const showPrices = sectionEl.dataset.showPrices !== "false";
    const showPopupPrices = sectionEl.dataset.showPopupPrices !== "false";
    const showSetTotal = sectionEl.dataset.showSetTotal !== "false";
    const showTotalPrice = sectionEl.dataset.showTotalPrice !== "false";

    const rules = {
      1: { min: Number(sectionEl.dataset.tab1Min || 0), max: Number(sectionEl.dataset.tab1Max || 1) },
      2: { min: Number(sectionEl.dataset.tab2Min || 0), max: Number(sectionEl.dataset.tab2Max || 1) }
    };

    const gridEl = ensure(sectionEl.querySelector("[data-bb-grid]"), "Grid not found");
    const msgEls = Array.from(sectionEl.querySelectorAll("[data-bb-msg]"));
    ensure(msgEls.length, "Msg not found");

    const prevBtn = ensure(sectionEl.querySelector("[data-bb-prev]"), "Prev not found");
    const nextBtn = ensure(sectionEl.querySelector("[data-bb-next]"), "Next not found");
    const addBtn = ensure(sectionEl.querySelector("[data-bb-add]"), "Add not found");
    const reviewHeadEl = sectionEl.querySelector("[data-bb-mobile-toggle]");
    const reviewTitleTextEl = reviewHeadEl?.querySelector(".bb__reviewtitle-text");
    const reviewTitleIconEl = reviewHeadEl?.querySelector(".bb__reviewtitle-icon");

    const clearBtn = ensure(sectionEl.querySelector("[data-bb-clear]"), "Clear not found");

    const totalEl = sectionEl.querySelector("[data-bb-total]");
    const setTotalEl = sectionEl.querySelector("[data-bb-set-total]");
    const modalEl = sectionEl.querySelector("[data-bb-modal]");
    const modalCloseEls = sectionEl.querySelectorAll("[data-bb-modal-close]");
    const qvThumbsEl = sectionEl.querySelector("[data-bb-qv-thumbs]");
    const qvMainImgEl = sectionEl.querySelector("[data-bb-qv-mainimg]");
    const qvTitleEl = sectionEl.querySelector("[data-bb-qv-title]");
    const qvPriceEl = sectionEl.querySelector("[data-bb-qv-price]");
    const qvSkuEl = sectionEl.querySelector("[data-bb-qv-sku]");
    const qvDescEl = sectionEl.querySelector("[data-bb-qv-desc]");
    const qvPriceCompareEl = sectionEl.querySelector("[data-bb-qv-price-compare]");
    const qvLinkEl = sectionEl.querySelector("[data-bb-qv-link]");
    const qvModalmidEl = sectionEl.querySelector(".bb__modalmid");

    const tabBtns = Array.from(sectionEl.querySelectorAll(".bb__tab"));
    const tabCounts = {
      1: ensure(sectionEl.querySelector('[data-bb-count="1"]'), "Count 1 not found"),
      2: ensure(sectionEl.querySelector('[data-bb-count="2"]'), "Count 2 not found")
    };

    const pickedEls = {
      1: ensure(sectionEl.querySelector('[data-bb-picked="1"]'), "Picked 1 not found"),
      2: ensure(sectionEl.querySelector('[data-bb-picked="2"]'), "Picked 2 not found")
    };

    const reviewTabs = {
      1: ensure(sectionEl.querySelector('[data-bb-reviewtab="1"]'), "Review tab 1 not found"),
      2: ensure(sectionEl.querySelector('[data-bb-reviewtab="2"]'), "Review tab 2 not found")
    };

    function saveSelections() {
      try {
        const handleSelections = { 1: {}, 2: {} };

        [1, 2].forEach((tab) => {
          Object.entries(selections[tab]).forEach(([variantId, qty]) => {
            const p = byVariantId.get(Number(variantId));
            if (!p) return;
            handleSelections[tab][String(p.productHandle)] = Number(qty) || 0;
          });
        });

        localStorage.setItem(
          storageKey,
          JSON.stringify({
            selections,
            handleSelections,
            activeTab
          })
        );
      } catch (e) {
        console.warn("Bundle storage save failed", e);
      }
    }

    function loadSelections() {
      try {
        const raw = localStorage.getItem(storageKey);
        if (!raw) return;

        const data = JSON.parse(raw);
        if (!data || typeof data !== "object") return;

        const nextSelections = { 1: {}, 2: {} };

        if (data.selections && typeof data.selections === "object") {
          [1, 2].forEach((tab) => {
            const map = data.selections[tab] || {};
            Object.entries(map).forEach(([variantId, qty]) => {
              const vid = Number(variantId);
              const q = Number(qty) || 0;
              if (q <= 0) return;

              if (byVariantId.has(vid)) {
                nextSelections[tab][vid] = q;
              }
            });
          });
        }

        if (data.handleSelections && typeof data.handleSelections === "object") {
          [1, 2].forEach((tab) => {
            const map = data.handleSelections[tab] || {};
            Object.entries(map).forEach(([handle, qty]) => {
              const q = Number(qty) || 0;
              if (q <= 0) return;

              const p = byHandle.get(String(handle));
              if (!p) return;

              const vid = Number(p.variantId);
              if (nextSelections[tab][vid]) return;

              nextSelections[tab][vid] = q;
            });
          });
        }

        selections[1] = nextSelections[1];
        selections[2] = nextSelections[2];

        if (data.activeTab) activeTab = Number(data.activeTab) || 1;
      } catch (e) {
        console.warn("Bundle storage load failed", e);
      }
    }

    function clearSelections() {
      selections[1] = {};
      selections[2] = {};

      try {
        localStorage.removeItem(storageKey);
      } catch (e) {}

      goTab(1);
      renderCounts();
      renderPicked();
      renderTotal();
      saveSelections();

      setMessage(msg.cleared);
    }

    let activeTab = 1;
    let searchQuery = "";

    // Mobil dokunmatik zoom için state
    let isZoomedMobile = false;
    let touchTranslateX = 0;
    let touchTranslateY = 0;
    let lastTapTime = 0;
    let lastTapX = 0;
    let lastTapY = 0;
    let lastTouchX = 0;
    let lastTouchY = 0;

    const selections = { 1: {}, 2: {} };

    const byVariantId = new Map(products.map((p) => [Number(p.variantId), p]));
    const byHandle = new Map(products.map((p) => [String(p.productHandle), p]));

    const MESSAGE_AUTO_HIDE_MS = 2500;
    let messageClearTimer = null;
    let showingTemporaryMessage = false;
    const tab1Label = sectionEl.dataset.tab1Label || "Sekme 1";
    const tab2Label = sectionEl.dataset.tab2Label || "Sekme 2";

    function formatMsg(template, vars) {
      if (!template || typeof template !== "string") return "";
      let s = template;
      Object.keys(vars || {}).forEach((k) => {
        s = s.split("{" + k + "}").join(String(vars[k] ?? ""));
      });
      return s;
    }

    const msg = {
      tab1BelowMin: sectionEl.dataset.msgTab1BelowMin || "En az {min} şapka seç. Şu an: {currentQty}/{min}",
      tab1Ok: sectionEl.dataset.msgTab1Ok || "Harika! Tüm şapka seçimleri yaptın {currentQty}/{max} (En az {min} seçim)",
      tab2BelowMin: sectionEl.dataset.msgTab2BelowMin || "Şimdi {tab2Label}. En az {min} Bench seçimi yap. Şu an: {currentQty}/{min}",
      tab2Ok: sectionEl.dataset.msgTab2Ok || "Harika! Şapkanı seçtin {max} adet daha Bench seçebilirsin. {currentQty}/{max} Şimdi sepete ekleyebilirsin.",
      maxReached: sectionEl.dataset.msgMaxReached || "Bu sekmede maksimum {max} seçim yapabilirsin.",
      tab1MinAdd: sectionEl.dataset.msgTab1MinAdd || "Sekme 1 için minimum {min} seçim yapmalısın.",
      tab2MinAdd: sectionEl.dataset.msgTab2MinAdd || "Sekme 2 için minimum {min} seçim yapmalısın.",
      productNotFound: sectionEl.dataset.msgProductNotFound || "Sepete eklenecek ürün bulunamadı.",
      addedToCart: sectionEl.dataset.msgAddedToCart || "Sepete eklendi. Sepete yönlendiriliyorsun...",
      addError: sectionEl.dataset.msgAddError || "Sepete eklerken hata oluştu. Konsolu kontrol et (F12).",
      readyAdd: sectionEl.dataset.msgReadyAdd || "Tamam! Şimdi sepete ekleyebilirsin.",
      cleared: sectionEl.dataset.msgCleared || "Seçimler temizlendi.",
      emptyPicked: sectionEl.dataset.msgEmptyPicked || "Henüz seçim yok",
      qvErrorTitle: sectionEl.dataset.msgQvErrorTitle || "Bir hata oluştu",
      qvErrorDesc: sectionEl.dataset.msgQvErrorDesc || "Ürün detayları yüklenemedi."
    };

    const MSG_COLOR_RED = "rgba(170, 8, 8, 0.95)";
    const MSG_COLOR_GREEN = "rgb(40 187 13 / 95%)";

    function updatePersistentHint() {
      if (showingTemporaryMessage) return;
      const currentQty = sumQty(selections[activeTab]);
      const { min, max } = rules[activeTab];
      const reachedMin = currentQty >= min;
      const vars = { min, max, currentQty, tab1Label, tab2Label };
      let text;
      if (activeTab === 1) {
        if (currentQty < min) {
          text = formatMsg(msg.tab1BelowMin, vars);
        } else {
          text = formatMsg(msg.tab1Ok, vars);
        }
      } else {
        if (currentQty < min) {
          text = formatMsg(msg.tab2BelowMin, vars);
        } else {
          text = formatMsg(msg.tab2Ok, vars);
        }
      }
      const color = reachedMin ? MSG_COLOR_GREEN : MSG_COLOR_RED;
      msgEls.forEach((el) => {
        el.textContent = text;
        el.style.opacity = "1";
        el.style.setProperty("color", color, "important");
      });
    }

    function setMessage(text, isError) {
      if (messageClearTimer) {
        clearTimeout(messageClearTimer);
        messageClearTimer = null;
      }
      if (!text || !String(text).trim()) {
        showingTemporaryMessage = false;
        updatePersistentHint();
        return;
      }
      showingTemporaryMessage = true;
      msgEls.forEach((el) => {
        el.textContent = text;
        el.style.opacity = "1";
        el.style.color = isError ? "#000" : "#000";
      });
      messageClearTimer = setTimeout(() => {
        messageClearTimer = null;
        showingTemporaryMessage = false;
        updatePersistentHint();
      }, MESSAGE_AUTO_HIDE_MS);
    }

    function canGoNextFromTab(tab) {
      const qty = sumQty(selections[tab]);
      return qty >= rules[tab].min;
    }

    function isMaxReached(tab) {
      const qty = sumQty(selections[tab]);
      return qty >= rules[tab].max;
    }

    function renderTabsState() {
      tabBtns.forEach((btn) => {
        const t = Number(btn.dataset.bbTab);
        btn.classList.toggle("is-active", t === activeTab);
      });

      const tab2Btn = tabBtns.find((b) => Number(b.dataset.bbTab) === 2);
      if (tab2Btn) {
        tab2Btn.disabled = !canGoNextFromTab(1);
      }

      prevBtn.disabled = activeTab === 1;
      const textNext = sectionEl.dataset.textBtnNext || "Devam";
      const textTab2Done = sectionEl.dataset.textBtnTab2Done || "Sekme 2 Tamam";
      nextBtn.textContent = activeTab === 1 ? textNext : textTab2Done;
      updatePersistentHint();

      reviewTabs[1].classList.toggle("is-active", activeTab === 1);
      reviewTabs[2].classList.toggle("is-active", activeTab === 2);
    }

    function renderCounts() {
      tabCounts[1].textContent = `(${sumQty(selections[1])})`;
      tabCounts[2].textContent = `(${sumQty(selections[2])})`;
    }

    function renderPicked() {
      [1, 2].forEach((tab) => {
        const listEl = pickedEls[tab];
        const entries = Object.entries(selections[tab])
          .map(([variantId, qty]) => ({
            p: byVariantId.get(Number(variantId)),
            qty: Number(qty)
          }))
          .filter((x) => x.p && x.qty > 0);

        if (!entries.length) {
          listEl.innerHTML = `<div style="opacity:.7;font-size:13px;">${escapeHtml(msg.emptyPicked)}</div>`;
          return;
        }

        listEl.innerHTML = entries
          .map(({ p, qty }) => {
            return `
              <div class="bb__pickeditem">
                <button
                  type="button"
                  class="bb__pickedremove"
                  data-bb-picked-remove
                  data-bb-tab="${tab}"
                  data-bb-variant-id="${p.variantId}"
                  aria-label="Seçimi kaldır"
                  title="Kaldır"
                >×</button>

                <div class="bb__pickedleft">
                  ${
                    p.image
                      ? `<img class="bb__pickedthumb" src="${p.image}" alt="" loading="lazy">`
                      : `<span class="bb__pickedthumb is-empty" aria-hidden="true"></span>`
                  }
                  <span class="bb__pickedname">${escapeHtml(p.title)}</span>
                </div>

                <strong class="bb__pickedqty">x${qty}</strong>
              </div>
            `;
          })
          .join("");
      });
    }

    // Önizleme fonksiyonları kaldırıldı - AI birleştirme olmadan kullanılmıyor

    function computeVisualTotalCents() {
      let total = 0;
      [1, 2].forEach((tab) => {
        Object.entries(selections[tab]).forEach(([variantId, qty]) => {
          const p = byVariantId.get(Number(variantId));
          if (!p) return;
          total += Number(p.priceCents) * Number(qty);
        });
      });
      return total;
    }

    function renderTotal() {
      const selectedCents = computeVisualTotalCents();

      // İndirimli Toplam: Seçilen ürünlerin toplamı
      if (showSetTotal && setTotalEl) {
        setTotalEl.textContent = formatMoney(selectedCents, moneyFormat);
      }

      // Set Toplam: Seçilen ürünlerin toplamı
      if (showTotalPrice && totalEl) {
        totalEl.textContent = formatMoney(selectedCents, moneyFormat);
      }
    }

    function openModal() {
      if (!modalEl) return;
      modalEl.classList.add("is-open");
      modalEl.setAttribute("aria-hidden", "false");
      modalEl.removeAttribute("inert");
      
      // Modal içindeki interaktif elementlerin tabindex'ini kaldır
      const interactiveElements = modalEl.querySelectorAll("button, a, input, textarea, select");
      interactiveElements.forEach((el) => {
        el.removeAttribute("tabindex");
      });
      
      document.documentElement.style.overflow = "hidden";
    }

    function closeModal() {
      if (!modalEl) return;
      modalEl.classList.remove("is-open");
      modalEl.setAttribute("aria-hidden", "true");
      modalEl.setAttribute("inert", "");
      
      resetImageZoom();
      
      // Modal içindeki interaktif elementlere tabindex="-1" ekle (focus'u engelle)
      const interactiveElements = modalEl.querySelectorAll("button, a, input, textarea, select");
      interactiveElements.forEach((el) => {
        el.setAttribute("tabindex", "-1");
      });
      
      document.documentElement.style.overflow = "";
    }

    function setQuickViewLoading() {
      if (qvThumbsEl) qvThumbsEl.innerHTML = "";
      if (qvMainImgEl) qvMainImgEl.src = "";
      if (qvTitleEl) qvTitleEl.textContent = "Yükleniyor…";
      if (qvPriceEl) qvPriceEl.textContent = "";
      if (qvSkuEl) qvSkuEl.textContent = "";
      if (qvDescEl) qvDescEl.innerHTML = "";
      if (qvPriceCompareEl) { qvPriceCompareEl.textContent = ""; qvPriceCompareEl.style.display = "none"; }
      if (qvLinkEl) qvLinkEl.href = "#";
      resetImageZoom();
    }

    function resetImageZoom() {
      isZoomedMobile = false;
      touchTranslateX = 0;
      touchTranslateY = 0;
      if (qvModalmidEl) qvModalmidEl.classList.remove("is-touch-zoomed");
      if (qvMainImgEl) {
        qvMainImgEl.style.transform = "";
        qvMainImgEl.style.transformOrigin = "";
      }
    }

    function updateHoverZoom(e) {
      if (!qvModalmidEl || !qvMainImgEl) return;
      const rect = qvModalmidEl.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const xPct = (x / rect.width) * 100;
      const yPct = (y / rect.height) * 100;
      qvMainImgEl.style.transformOrigin = `${xPct}% ${yPct}%`;
      qvMainImgEl.style.transform = "scale(2.5)";
    }

    function clearHoverZoom() {
      if (!qvMainImgEl) return;
      qvMainImgEl.style.transform = "";
      qvMainImgEl.style.transformOrigin = "";
    }

    function moneyFromCents(cents) {
      return formatMoney(Number(cents), moneyFormat);
    }

    async function openQuickView(handle, variantId) {
      if (!handle) return;
      setQuickViewLoading();
      openModal();

      try {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) throw new Error("Ürün detayı alınamadı");
        const data = await res.json();

        if (qvTitleEl) qvTitleEl.textContent = data.title || "";

        const v =
          (data.variants || []).find((x) => Number(x.id) === Number(variantId)) ||
          (data.variants || [])[0];
        if (v) {
          if (showPopupPrices) {
            const priceCents = Number(v.price) || 0;
            const compareCents = Number(v.compare_at_price) || 0;
            const hasDiscount = compareCents > 0 && compareCents > priceCents;
            if (qvPriceEl) {
              qvPriceEl.textContent = moneyFromCents(priceCents);
              qvPriceEl.classList.toggle("bb__qvprice--sale", hasDiscount);
            }
            if (qvPriceCompareEl) {
              if (hasDiscount) {
                qvPriceCompareEl.textContent = moneyFromCents(compareCents);
                qvPriceCompareEl.style.display = "";
              } else {
                qvPriceCompareEl.textContent = "";
                qvPriceCompareEl.style.display = "none";
              }
            }
          } else {
            if (qvPriceEl) qvPriceEl.textContent = "";
            if (qvPriceCompareEl) { qvPriceCompareEl.textContent = ""; qvPriceCompareEl.style.display = "none"; }
          }
          if (qvSkuEl) qvSkuEl.textContent = v.sku ? `SKU: ${v.sku}` : "";
        } else {
          if (qvPriceEl) qvPriceEl.textContent = "";
          if (qvPriceCompareEl) { qvPriceCompareEl.textContent = ""; qvPriceCompareEl.style.display = "none"; }
          if (qvSkuEl) qvSkuEl.textContent = "";
        }

        if (qvDescEl) qvDescEl.innerHTML = data.description || "";

        // Ürün linkini set et
        if (qvLinkEl) {
          qvLinkEl.href = `/products/${handle}`;
        }

        const images = data.images || [];
        const first = images[0] || "";
        if (qvMainImgEl) qvMainImgEl.src = first;

        if (qvThumbsEl) {
          qvThumbsEl.innerHTML = images
            .map((src, i) => {
              return `<img class="bb__thumb ${i === 0 ? "is-active" : ""}" src="${src}" alt="" loading="lazy" data-bb-qv-thumb data-src="${src}">`;
            })
            .join("");
        }
      } catch (e) {
        if (qvTitleEl) qvTitleEl.textContent = msg.qvErrorTitle;
        if (qvDescEl) qvDescEl.textContent = msg.qvErrorDesc;
        console.error(e);
      }
    }
    function renderCollectionsDropdown() {
      if (!collectionsSelect) return;

      const tab = activeTab;
      const items = collectionsByTab[tab] || [];
      const hasAnyCollections = collections.length > 0;

      collectionsSelect.innerHTML = "";
      if (!items.length) {
        const opt = document.createElement("option");
        opt.value = "";
        opt.textContent = "Koleksiyon yok";
        collectionsSelect.appendChild(opt);
        if (collectionsWrap) collectionsWrap.style.display = hasAnyCollections ? "flex" : "none";
        return;
      }

      if (collectionsWrap) collectionsWrap.style.display = "flex";

      // Eğer daha önce seçili handle bu tab listesinde yoksa sıfırla
      const stillExists = items.some((x) => x.handle === activeCollection[tab]);
      if (!stillExists) activeCollection[tab] = null;

      // aktif koleksiyon yoksa ilkini seç
      const current = activeCollection[tab] || items[0].handle;
      activeCollection[tab] = current;

      // optionları bas
      items.forEach((c) => {
        const opt = document.createElement("option");
        opt.value = String(c.handle || "").trim();
        opt.textContent = (String(c.title || c.handle || "").trim()) || "—";
        if (opt.value && opt.value === current) opt.selected = true;
        collectionsSelect.appendChild(opt);
      });
    }

    function getVisibleProducts() {
      let list = products.filter((p) => Number(p.tab) === activeTab);

      const h = activeCollection[activeTab];
      if (h) {
        list = list.filter((p) => String(p.collectionHandle || "") === String(h));
      }

      // Arama sorgusu varsa filtrele
      if (searchQuery && searchQuery.trim()) {
        const query = searchQuery.trim().toLowerCase();
        list = list.filter((p) => {
          const title = String(p.title || "").toLowerCase();
          return title.includes(query);
        });
      }

      // Aynı ürün birden fazla kez geldiyse (farklı kaynaklardan) tekilleştir
      const seen = new Set();
      list = list.filter((p) => {
        const vid = Number(p.variantId);
        if (!vid) return false;
        if (seen.has(vid)) return false;
        seen.add(vid);
        return true;
      });

      return list;
    }

    function renderGrid() {
      setMessage("");
      const visible = getVisibleProducts();

      if (!visible.length) {
        gridEl.innerHTML = `<div class="bb__empty" style="width:100%; padding:40px 20px; text-align:center; opacity:.6; font-size:14px;">Ürün bulunamadı. Arama terimini değiştirmeyi deneyin.</div>`;
        return;
      }

      gridEl.innerHTML = visible
        .map((p) => {
          const variantId = Number(p.variantId);
          const qty = selections[activeTab][variantId] || 0;
          const maxReached = isMaxReached(activeTab);

          const plusDisabled = !p.available || (maxReached && qty === 0);
          const minusDisabled = qty === 0;

          return `
          <div class="bb__card" data-variant-id="${variantId}">
            <div class="bb__media" data-bb-quickview data-handle="${p.productHandle}" data-variant-id="${variantId}" role="button" tabindex="0" aria-label="Ürünü incele" title="Ürünü incele">
                <img class="bb__img" src="${p.image || ""}" alt="${escapeHtml(p.title)}">
              </div>

            <div class="bb__body">
              <div class="bb__title">${escapeHtml(p.title)}</div>
              ${showPrices ? (() => {
                const priceCents = Number(p.priceCents || 0);
                const compareAtPriceCents = Number(p.compareAtPriceCents || 0);
                const hasDiscount = compareAtPriceCents > 0 && compareAtPriceCents > priceCents;
                
                if (hasDiscount) {
                  return `
                    <div class="bb__price">
                      <div class="bb__price-discounted">
                        <ins class="bb__price-sale">${formatMoney(priceCents, moneyFormat)}</ins>
                        <del class="bb__price-original">${formatMoney(compareAtPriceCents, moneyFormat)}</del>
                      </div>
                    </div>
                  `;
                } else {
                  return `<div class="bb__price">${formatMoney(priceCents, moneyFormat)}</div>`;
                }
              })() : '<div class="bb__price" style="display:none;"></div>'}

              <div class="bb__row">
                <div class="bb__qty">
                  <button type="button" class="bb__iconbtn" data-bb-minus ${minusDisabled ? "disabled" : ""}>-</button>
                  <span class="bb__qtynum">${qty}</span>
                  <button type="button" class="bb__iconbtn" data-bb-plus ${plusDisabled ? "disabled" : ""}>+</button>
                </div>
                <div style="font-size:12px;opacity:.7">${p.available ? "" : "Stok yok"}</div>
              </div>
            </div>
          </div>
        `;
        })
        .join("");

      Array.from(gridEl.querySelectorAll(".bb__card")).forEach((card) => {
        const variantId = Number(card.getAttribute("data-variant-id"));
        const plus = card.querySelector("[data-bb-plus]");
        const minus = card.querySelector("[data-bb-minus]");

        plus && plus.addEventListener("click", () => changeQty(variantId, +1, card));
        minus && minus.addEventListener("click", () => changeQty(variantId, -1, card));
      });
    }

    function changeQty(variantId, delta, sourceCardEl) {
      setMessage("");

      const p = byVariantId.get(Number(variantId));
      if (!p || !p.available) return;

      const current = selections[activeTab][variantId] || 0;
      const next = current + delta;

      if (next < 0) return;

      const totalBefore = sumQty(selections[activeTab]);
      const totalAfter = totalBefore + delta;

      if (delta > 0 && totalAfter > rules[activeTab].max) {
        setMessage(formatMsg(msg.maxReached, { max: rules[activeTab].max }), true);
        return;
      }

      if (next === 0) delete selections[activeTab][variantId];
      else selections[activeTab][variantId] = next;

      renderGrid();
      renderCounts();
      renderPicked();
      renderTotal();
      renderTabsState();
      saveSelections();

      if (delta > 0 && activeTab === 1 && isMaxReached(1)) {
        if (canGoNextFromTab(1)) {
          goTab(2);
        }
      }

      if (delta > 0 && isMobileView() && isMaxReached(activeTab)) {
        const alreadyOpen = sectionEl.classList.contains("is-mobile-expanded");
        if (!alreadyOpen) setMobileExpanded(true);

        if (sourceCardEl && sourceCardEl.scrollIntoView) {
          setTimeout(() => {
            sourceCardEl.scrollIntoView({ behavior: "smooth", block: "center" });
          }, 250);
        }
      }
    }

    function goTab(tab) {
      activeTab = tab;
      // Tab değişince arama sorgusunu temizle
      if (searchInput) {
        searchInput.value = "";
        searchQuery = "";
      }
      renderCollectionsDropdown();
      renderGrid();
      renderTabsState();
      saveSelections();
    }


    async function addToCart() {
      setMessage("");

      if (!canGoNextFromTab(1)) {
        setMessage(formatMsg(msg.tab1MinAdd, { min: rules[1].min }), true);
        goTab(1);
        return;
      }
      if (sumQty(selections[2]) < rules[2].min) {
        setMessage(formatMsg(msg.tab2MinAdd, { min: rules[2].min }), true);
        goTab(2);
        return;
      }

      // Seçilen tüm ürünleri topla
      // Tab 1 seçimlerini en son ekle ki sepette en üstte görünsün
      const itemsToAdd = [];
      [2, 1].forEach((tab) => {
        Object.entries(selections[tab]).forEach(([variantId, qty]) => {
          const p = byVariantId.get(Number(variantId));
          if (!p || !qty || qty <= 0) return;
          itemsToAdd.push({
            id: Number(variantId),
            quantity: Number(qty)
          });
        });
      });

      if (itemsToAdd.length === 0) {
        setMessage(msg.productNotFound, true);
        return;
      }

      addBtn.disabled = true;
      addBtn.textContent = "Ekleniyor...";

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: itemsToAdd
          })
        });

        if (!res.ok) {
          const txt = await res.text();
          throw new Error(txt || "Cart add failed");
        }

        setMessage(msg.addedToCart);
        window.location.href = "/cart";
      } catch (e) {
        console.error(e);
        setMessage(msg.addError, true);
      } finally {
        addBtn.disabled = false;
        addBtn.textContent = "Sepete Ekle";
      }
    }

    tabBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        const t = Number(btn.dataset.bbTab);
        if (t === 2 && !canGoNextFromTab(1)) return;
        goTab(t);
      });
    });

    prevBtn.addEventListener("click", () => goTab(1));

    nextBtn.addEventListener("click", () => {
      if (activeTab === 1) {
        if (!canGoNextFromTab(1)) {
          setMessage(formatMsg(msg.tab1MinAdd, { min: rules[1].min }), true);
          return;
        }
        goTab(2);
      } else {
        if (sumQty(selections[2]) < rules[2].min) {
          setMessage(formatMsg(msg.tab2MinAdd, { min: rules[2].min }), true);
          return;
        }
        setMessage(msg.readyAdd);
      }
    });

    clearBtn.addEventListener("click", clearSelections);

    [1, 2].forEach((tab) => {
      const listEl = pickedEls[tab];
      listEl.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-bb-picked-remove]");
        if (!btn) return;

        const t = Number(btn.dataset.bbTab);
        const variantId = Number(btn.dataset.bbVariantId);

        if (!t || !variantId) return;

        delete selections[t][variantId];

      renderGrid();
      renderCounts();
      renderPicked();
      renderTotal();
      renderTabsState();

        saveSelections();
      });
    });

    addBtn.addEventListener("click", addToCart);

    function handleQuickViewTrigger(el) {
      if (!el) return;
      const handle = el.getAttribute("data-handle");
      const variantId = Number(el.getAttribute("data-variant-id"));
      openQuickView(handle, variantId);
    }

    gridEl.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-bb-quickview]");
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      handleQuickViewTrigger(btn);
    });

    gridEl.addEventListener("keydown", (e) => {
      const btn = e.target.closest("[data-bb-quickview]");
      if (!btn || (e.key !== "Enter" && e.key !== " ")) return;
      e.preventDefault();
      handleQuickViewTrigger(btn);
    });

    modalCloseEls && modalCloseEls.forEach((el) => {
      el.addEventListener("click", closeModal);
    });

    if (modalEl) {
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && modalEl.classList.contains("is-open")) {
          closeModal();
        }
      });
    }

    if (qvThumbsEl) {
      qvThumbsEl.addEventListener("click", (e) => {
        const t = e.target.closest("[data-bb-qv-thumb]");
        if (!t) return;
        const src = t.getAttribute("data-src");
        if (qvMainImgEl && src) qvMainImgEl.src = src;

        qvThumbsEl.querySelectorAll(".bb__thumb").forEach((x) => x.classList.remove("is-active"));
        t.classList.add("is-active");
        
        resetImageZoom();
      });
    }

    // Fare ile üzerine gelince yakınlaştırma, hareketle farklı yerlere bakma (masaüstü)
    // Mobil: çift dokunma ile yakınlaştır, elle kaydırarak incele
    const hasTouch = "ontouchstart" in window;
    if (qvModalmidEl) {
      if (!hasTouch) {
        qvModalmidEl.addEventListener("mouseenter", (e) => updateHoverZoom(e));
        qvModalmidEl.addEventListener("mousemove", (e) => updateHoverZoom(e));
        qvModalmidEl.addEventListener("mouseleave", clearHoverZoom);
      } else {
        qvModalmidEl.addEventListener("touchstart", (e) => {
          if (!e.touches.length) return;
          const x = e.touches[0].clientX;
          const y = e.touches[0].clientY;
          const now = Date.now();
          const isDoubleTap = (now - lastTapTime) < 400 && Math.abs(x - lastTapX) < 40 && Math.abs(y - lastTapY) < 40;
          if (isZoomedMobile) {
            if (isDoubleTap) {
              resetImageZoom();
              lastTapTime = 0;
              lastTapX = 0;
              lastTapY = 0;
              return;
            }
            lastTouchX = x;
            lastTouchY = y;
            lastTapTime = now;
            lastTapX = x;
            lastTapY = y;
          } else {
            if (isDoubleTap) {
              isZoomedMobile = true;
              touchTranslateX = 0;
              touchTranslateY = 0;
              if (qvModalmidEl) qvModalmidEl.classList.add("is-touch-zoomed");
              if (qvMainImgEl) {
                qvMainImgEl.style.transformOrigin = "50% 50%";
                qvMainImgEl.style.transform = "translate(0px, 0px) scale(2.5)";
              }
            }
            lastTapTime = now;
            lastTapX = x;
            lastTapY = y;
          }
        }, { passive: true });
        qvModalmidEl.addEventListener("touchmove", (e) => {
          if (!isZoomedMobile || !e.touches.length || !qvMainImgEl) return;
          e.preventDefault();
          const rect = qvModalmidEl.getBoundingClientRect();
          const dx = e.touches[0].clientX - lastTouchX;
          const dy = e.touches[0].clientY - lastTouchY;
          touchTranslateX += dx;
          touchTranslateY += dy;
          const maxX = Math.max(rect.width * 0.5, 60);
          const maxY = Math.max(rect.height * 0.5, 60);
          touchTranslateX = Math.max(-maxX, Math.min(maxX, touchTranslateX));
          touchTranslateY = Math.max(-maxY, Math.min(maxY, touchTranslateY));
          lastTouchX = e.touches[0].clientX;
          lastTouchY = e.touches[0].clientY;
          qvMainImgEl.style.transform = `translate(${touchTranslateX}px, ${touchTranslateY}px) scale(2.5)`;
        }, { passive: false });
      }
    }

    function setMobileExpanded(expanded) {
      sectionEl.classList.toggle("is-mobile-expanded", !!expanded);
      
      // Mobil başlık
      if (reviewHeadEl) {
        reviewHeadEl.setAttribute("aria-expanded", expanded ? "true" : "false");
      }
      if (reviewTitleTextEl) {
        reviewTitleTextEl.textContent = expanded ? "Seçimlerini Gizle" : "Seçimlerini Gör";
      }
      if (reviewTitleIconEl) {
        reviewTitleIconEl.textContent = expanded ? "▼" : "▲";
      }
    }

    function isMobileView() {
      return window.matchMedia && window.matchMedia("(max-width: 768px)").matches;
    }

    if (reviewHeadEl) {
      reviewHeadEl.addEventListener("click", () => {
        if (!isMobileView()) return;
        const willExpand = !sectionEl.classList.contains("is-mobile-expanded");
        setMobileExpanded(willExpand);
      });
      reviewHeadEl.addEventListener("keydown", (e) => {
        if (!isMobileView()) return;
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          const willExpand = !sectionEl.classList.contains("is-mobile-expanded");
          setMobileExpanded(willExpand);
        }
      });
    }

    if (collectionsSelect) {
      collectionsSelect.addEventListener("change", (e) => {
        activeCollection[activeTab] = e.target.value;
      renderGrid();
      renderTabsState();
      updatePersistentHint();
      });
    }

    let searchClickOutsideHandler = null;

    function toggleSearch(expanded) {
      if (!searchEl) return;
      const isMobile = window.matchMedia && window.matchMedia("(max-width: 768px)").matches;
      
      if (expanded) {
        searchEl.classList.remove("is-collapsed");
        searchEl.classList.add("is-expanded");
        if (searchInput) {
          setTimeout(() => searchInput.focus(), 300);
        }
        
        // Mobilde click outside listener ekle
        if (isMobile && searchWrapper) {
          if (searchClickOutsideHandler) {
            document.removeEventListener("click", searchClickOutsideHandler);
          }
          searchClickOutsideHandler = (e) => {
            if (searchEl.classList.contains("is-expanded")) {
              if (!searchWrapper.contains(e.target) && searchToggle && !searchToggle.contains(e.target)) {
                toggleSearch(false);
                searchQuery = "";
                if (searchInput) searchInput.value = "";
                renderGrid();
              }
            }
          };
          setTimeout(() => {
            document.addEventListener("click", searchClickOutsideHandler);
          }, 100);
        }
      } else {
        searchEl.classList.remove("is-expanded");
        searchEl.classList.add("is-collapsed");
        
        // Click outside listener'ı temizle
        if (searchClickOutsideHandler) {
          document.removeEventListener("click", searchClickOutsideHandler);
          searchClickOutsideHandler = null;
        }
      }
    }

    if (searchToggle && searchEl) {
      // Mobilde başlangıçta kapalı - input kapalı ama ikon görünür
      const checkMobile = () => {
        return window.matchMedia && window.matchMedia("(max-width: 768px)").matches;
      };
      
      let wasMobile = checkMobile();
      
      // Sayfa yüklendiğinde mobil kontrolü yap (sadece ilk yüklemede)
      if (wasMobile) {
        searchEl.classList.add("is-collapsed");
        searchEl.classList.remove("is-expanded");
      } else {
        // Desktop'ta class'ları temizle
        searchEl.classList.remove("is-collapsed");
        searchEl.classList.remove("is-expanded");
      }

      // Resize'da sadece mobil/desktop geçişi varsa kontrol et (debounce ile)
      let resizeTimeout = null;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          const isMobile = checkMobile();
          // Sadece mobil/desktop geçişi olduğunda class'ları güncelle
          if (isMobile !== wasMobile) {
            wasMobile = isMobile;
            if (isMobile) {
              // Mobilde geçiş - eğer açık değilse kapalı yap (açıksa açık bırak)
              if (!searchEl.classList.contains("is-expanded")) {
                searchEl.classList.add("is-collapsed");
                searchEl.classList.remove("is-expanded");
              }
            } else {
              // Desktop'a geçiş - class'ları temizle
              if (searchClickOutsideHandler) {
                document.removeEventListener("click", searchClickOutsideHandler);
                searchClickOutsideHandler = null;
              }
              searchEl.classList.remove("is-collapsed");
              searchEl.classList.remove("is-expanded");
            }
          }
        }, 150);
      });

      searchToggle.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isExpanded = searchEl.classList.contains("is-expanded");
        toggleSearch(!isExpanded);
      });
    }

    if (searchInput) {
      searchInput.addEventListener("input", (e) => {
        searchQuery = e.target.value || "";
        renderGrid();
      });

    }

    loadSelections();
    renderCollectionsDropdown();
    renderGrid();
    renderCounts();
    renderPicked();
    renderTotal();
    renderTabsState();
    saveSelections();
  }

  function escapeHtml(str) {
    return String(str || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".bb[data-section-id]").forEach(initBundleBuilder);
  });
})();
